/**
 * Shell + header, so the loaded detail page and its failure states wear the
 * same chrome instead of dropping the operator onto a bare error string.
 */
import type { ReactNode } from 'react';

import { DashboardsPage } from '../../dashboards/DashboardsPage';
import { ReviewPageHeader } from '../ReviewPageHeader';

export const QUEUE_PATH = '/admin/needs-review';

export default function ReviewDetailShell({
  crumb,
  title,
  isPhone,
  actions,
  children,
}: {
  crumb: string;
  title: string;
  isPhone: boolean;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <DashboardsPage
      // The children are a two-column grid on desktop and own their own gaps, so
      // the page must not add one on top.
      stack={false}
      // The phone layout has a FIXED action bar; without the reserved gutter the
      // last card sits under it and cannot be scrolled to.
      hasPhoneBottomBar
      header={
        <ReviewPageHeader
          crumb={crumb}
          title={title}
          backTo={QUEUE_PATH}
          compact={isPhone}
          actions={isPhone ? null : actions}
        />
      }
    >
      {children}
    </DashboardsPage>
  );
}
